import React, { useState, useEffect } from "react";
import {
  Box,
  Autocomplete,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField
} from "@mui/material";

import {
  getMentorEmail,
  getMentorName
} from "../../../../../core/service/mentor.service";
import { InputField, SelectField, DatePickerField } from "../../FormFields";
import { useField, useFormikContext } from "formik";
import { facultyOption } from "../../../../../_mock_/faculty";

// const mentorNameOption = [
//   {
//     value: "a",
//     label: "นาย A"
//   },
//   {
//     value: "b",
//     label: "นาย B"
//   },
//   {
//     value: "c",
//     label: "นาง C"
//   }
// ];

// const mentorEmailOption = [
//   {
//     value: "a",
//     label: "A@gmail.com"
//   },
//   {
//     value: "b",
//     label: "B@gmail.com"
//   },
//   {
//     value: "c",
//     label: "C@gmail.com"
//   }
// ];

const fieldResearchOption = [
  {
    value: "healthScience",
    label: "Health Science"
  },
  {
    value: "physicalScience",
    label: "Physical Science"
  },
  {
    value: "socialScience",
    label: "Social Science"
  },
  {
    value: "humanScience",
    label: "Human Science"
  }
];

export default function PersonalInformation2(props) {
  const formikProps = useFormikContext();
  const [mentorNameOption, setMentorNameOption] = useState([
    { value: "", label: "" }
  ]);
  const [mentorEmailOption, setMentorEmailOption] = useState([
    { value: "", label: "" }
  ]);

  useEffect(() => {
    const getMentorNameAndEmail = async () => {
      const mentorName = await getMentorName();
      const mentorEmail = await getMentorEmail();
      setMentorNameOption(mentorName);
      setMentorEmailOption(mentorEmail);
    };

    getMentorNameAndEmail();
  }, []);

  const {
    formField: {
      faculty,
      department,
      mobileThai,
      mobileCountry,
      mentor_id,
      mentorName,
      mentorEmail,
      startFellowship,
      contractEnd,
      fieldResearch,
      addressInThailand,
      addressInTheCountryOfResidence,
      studentId
    }
  } = props;

  const [mentorNameField, mentorNameMeta] = useField(mentorName);
  const [mentorEmailField, mentorEmailMeta] = useField(mentorEmail);

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Personal Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={faculty.name}
            label={faculty.label}
            data={facultyOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={department.name}
            label={department.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={mobileThai.name}
            label={mobileThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={mobileCountry.name}
            label={mobileCountry.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={studentId.name}
            label={studentId.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Autocomplete
            options={mentorNameOption}
            onChange={(e, result) => {
              formikProps.setFieldValue(mentor_id.name, result.value);
              formikProps.setFieldValue(mentorName.name, result.label);
              formikProps.setFieldValue(mentorEmail.name, result.value);
            }}
            value={mentorNameField.value}
            isOptionEqualToValue={(option, value) => option.label === value}
            renderInput={(params) => (
              <TextField
                name={mentorNameField.name}
                label={mentorName.label}
                error={Boolean(mentorNameMeta.touched && mentorNameMeta.error)}
                helperText={mentorNameMeta.touched && mentorNameMeta.error}
                {...params}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl fullWidth disabled>
            <InputLabel>{mentorEmail.label}</InputLabel>
            <Select
              name={mentorEmail.name}
              value={mentorEmailField.value}
              label={mentorEmail.label}
            >
              {mentorEmailOption.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={7}>
          <DatePickerField
            name={startFellowship.name}
            label={startFellowship.label}
            inputFormat="dd/MM/yyyy"
            // disableFuture
            minDate={new Date("1950/12/31")}
          />
        </Grid>

        <Grid item xs={12} sm={5}>
          <DatePickerField
            // name={contractEnd.name}
            // label={contractEnd.label}
            // format="MM/yy"
            // views={["year", "month"]}
            // minDate={new Date("1980/12/31")}
            // maxDate={new Date()}
            // fullWidth
            // inputVariant="outlined"

            name={contractEnd.name}
            label={contractEnd.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={fieldResearch.name}
            label={fieldResearch.label}
            data={fieldResearchOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={addressInThailand.name}
            label={addressInThailand.label}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={addressInTheCountryOfResidence.name}
            label={addressInTheCountryOfResidence.label}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
